import get from '../../../lib/requests';
import { CANCEL } from 'redux-saga';
import axios from 'axios';

export function requestGetProducts(filters) {
	const ourRequest = axios.CancelToken.source();
	const promise = get(
		`/api/product-list?category=${filters.code}&brandcodes=${filters.brandCode}&attrvalues=${filters.attrvalues}&stock=${filters.stock}&currentpage=${filters.currentpage}&page=${filters.currentpage}&showitems=${filters.showitems}&supplier=${filters.supplier}&searchtxt=${filters.searchtext}&pricefrom=${filters.pricefrom}&priceto=${filters.priceto}&singleattribute=${filters.singleattribute}&singlebrand=${filters.singlebrand}&sortby=${filters.sortby}&stockout=${filters.stockout}&minorcats=${filters.minorcats}&promotion=${filters.promotion}`,
		true,
		ourRequest.token
	);
	promise[CANCEL] = () => ourRequest.cancel();
	return promise;
}
export function requestGetProductsTotal(filters) {
	const ourRequest = axios.CancelToken.source();
	const promise = get(
		`/api/products/totals?category=${filters.code}&brandcodes=${filters.brandCode}&attrvalues=${filters.attrvalues}&stock=${filters.stock}&currentpage=${filters.currentpage}&page=${filters.currentpage}&showitems=${filters.showitems}&supplier=${filters.supplier}&searchtxt=${filters.searchtext}&pricefrom=${filters.pricefrom}&priceto=${filters.priceto}&singleattribute=${filters.singleattribute}&singlebrand=${filters.singlebrand}&sortby=${filters.sortby}&stockout=${filters.stockout}&minorcats=${filters.minorcats}&promotion=${filters.promotion}`,
		false,
		ourRequest.token
	);
	promise[CANCEL] = () => ourRequest.cancel();
	return promise;
}
export function requestGetProduct(sku) {
	const ourRequest = axios.CancelToken.source();
	const promise = get(`api/product/${sku}`, false, ourRequest.token);
	promise[CANCEL] = () => ourRequest.cancel();
	return promise;
}
